<template>
  <v-app>
    <Cabecalho />

    <v-content>
      <Router-View />
    </v-content>
    <Chat v-if="!inicio()" />
  </v-app>
</template>

<script>
import Cabecalho from "./components/Cabecalho";
import Chat from "./components/Chat";
import { mapGetters } from "vuex";
import Alert from "./utils/alert";
import Constantes from "./utils/constantes";

export default {
  name: "App",

  components: {
    Cabecalho,
    Chat,
  },

  data: () => ({
    URL_SERVIDOR: Constantes.URL_SERVIDOR,
    dialog: false,
    drawer: null,
  }),
  mounted() {
    this.$store.dispatch("anuncio/carregarEmpresa", this.$route.params.id);
  },
  methods: {
    items() {
      let items = [];
      if (this.user) {
        items = [
          {
            icon: "las la-tag",
            text: "Ofertas",
            to: `/${this.$route.params.id}/anuncio`,
          },
          {
            icon: "las la-shopping-cart",
            text: "Pedidos",
            to: `/${this.$route.params.id}/pedidos`,
          },
          {
            icon: "las la-lock",
            text: "Trocar Senha",
            to: `/${this.$route.params.id}/trocarsenha`,
          },
          // {
          //   icon: "las la-question-circle",
          //   text: "Ajuda",
          //   to: `/${this.$route.params.id}/sobre`,
          // },
        ];
      } else {
        items = [
          {
            icon: "las la-tag",
            text: "Ofertas",
            to: `/${this.$route.params.id}/anuncio`,
          },
          // {
          //   icon: "las la-question-circle",
          //   text: "Ajuda",
          //   to: `/${this.$route.params.id}/sobre`,
          // },
        ];
      }
      return items;
    },
    logout() {
      this.$store.dispatch("cliente/logout");
      this.$router.push({ name: "login" });
    },
    home() {
      // console.log("home");
      this.$router.push({ name: "home" });
    },
    carrinho() {
      // console.log("carrinho");
      this.$router.push({ name: "carrinho" });
    },
    inicio() {
      // console.log(
      //   "this.$router.currentRoute.name",
      //   this.$router.currentRoute.name
      // );
      return (
        this.$router.currentRoute.name === "login" ||
        this.$router.currentRoute.name === "registro" ||
        this.$router.currentRoute.name === "home"
      );
    },
    // verificarMensagensNovas() {
    //   // console.log("temMensagem?", this.temMensagem);
    //   if (this.user && this.loading === false && this.user.cliIntCod) {
    //     this.$store.dispatch("chat/verificarMensagensNovas", {
    //       cliIntCod: this.user.cliIntCod,
    //     });
    //   }
    //   if (this.temMensagem === true) {
    //     // console.log("temMensagem, carregarMensagensNovas", this.temMensagem);
    //     this.carregarMensagensNovas();
    //   }
    // },
    // carregarMensagensNovas() {
    //   if (this.user && this.user.cliIntCod) {
    //     // console.log("APPcarregarMensagensNovas" , "cliIntCod", this.user.cliIntCod, "chtIntCod", this.ultimamsg);
    //     this.$store.dispatch("chat/carregarMensagensNovas", {
    //       cliIntCod: this.user.cliIntCod,
    //       chtIntCod: this.ultimamsg,
    //     });
    //   }
    // },
    // carregarCarrinho() {
    //   if (this.user && this.loading === false && this.user.cliIntCod) {
    //     this.$store.dispatch("pedido/carregarCarrinho", this.user.cliIntCod);
    //   }
    // },
  },
  timers: {
    // verificarMensagensNovas: { time: 5000, autostart: true, repeat: true },
    //carregarCarrinho: { time: 6000, autostart: true, repeat: true },
  },
  computed: {
    ...mapGetters({
      user: "cliente/user",
      ultimamsg: "chat/ultimamsg",
      empresa: "anuncio/empresa",
      token: "cliente/token",
      contadorCarrinho: "pedido/contadorCarrinho",
      error: "core/error",
      success: "core/success",
      loading: "core/loading",
      funcionarioResponsavel: "cliente/funcionarioResponsavel",
      temMensagem: "chat/temMensagem",
      usuarioLogado: "cliente/usuarioLogado",
    }),
  },
  watch: {
    error(value) {
      if (value) {
        let { error, status, message } = value;
        console.log("erro", error, status, message);
        if (status !== undefined) {
          if (status === 403) {
            this.logout();
            Alert.error("Sessão Expirada!");
          } else {
            Alert.error(error, `${status}: ${message}`);
          }
        } else {
          if (message.includes("403")) {
            this.logout();
            Alert.error("Sessão Expirada!");
          } else {
            Alert.error(error, `${message}`);
          }
        }
        this.$store.dispatch("core/clearError");
      }
    },
    success(value) {
      if (value) {
        // console.log(value);
        Alert.success(value.title, value.message);
        this.$store.dispatch("core/clearSuccess");
      }
    },
  },
};
</script>

<style>
@import "./assets/cores_sistema.css";
@import "./assets/style_b2c.css";
</style>
